import {Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {SectionDTO} from '../dto/section.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Get All Section Details **/
  getAllSections(): Observable<Array<SectionDTO>> {
    return this.httpClient.get<Array<SectionDTO>>(this.BASE_URL + 'section' + "/all")
  }
}
